module.exports = __webpack_public_path__ + "static/media/PUMA-Pink-Low-tops-Sneakers-Lyst.d0b47af5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/sneakers/PUMA-Pink-Low-tops-Sneakers-Lyst.png
// module id = 310
// module chunks = 0